import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';
import StickyBox from 'react-sticky-box';

import { useShowFilters } from 'src/routes/Checkout/CheckoutRoutes/PackageCheckout/store/flights-filters';

import SidebarHotel from 'src/routes/Checkout/CheckoutRoutes/PackageCheckout/components/Hotel/SidebarHotel';
import SidebarMenu from 'checkout/components/Sidebar/components/SidebarMenu';

import SidebarSummary from 'checkout/components/Sidebar/components/SidebarSummary';
import { scrollToElement } from 'src/utils/domUtils';
import { Client, Tourists } from './components/SideBarItems';

import SidebarFlight from './components/SidebarFlight';
import { FiltersPanelDesktop } from '../../CheckoutRoutes/PackageCheckout/components/FlightsFilterPanel';

import TransferMedInsuranceInfo from '../TransferMedInsuranceInfo';

import styles from './sidebar.module.css';

const baseCls = 'checkout-sidebar';
const topCls = `${baseCls}-top`;

const Sidebar = ({
  isFirstStepDone,
  clientData,
  touristsData,
  isHomePath,
  isTouristsConfirmed,
  isClientConfirmed,
  isManualPackage,
  isBusinessFlight,
  goToClient,
  goToTourists,
  isOrderFinished,
  flightsCount,
  stickyOffset,
  isHotelOnly,
  transferMedInsurance,
}) => {
  React.useEffect(() => {
    const bottomYCoordOfSidebar =
      document.querySelector(`.StickySidebarBox`).getBoundingClientRect()
        .bottom + window.scrollY;

    const topYCoordOfFooter =
      document.querySelector(`.footer`)?.getBoundingClientRect().top +
      window.scrollY;

    if (bottomYCoordOfSidebar > topYCoordOfFooter) {
      scrollToElement(document.querySelector('.checkout_page_new__main'));
    }
  }, [flightsCount]);
  const [showFilters] = useShowFilters();

  const { insurance, transfer } = transferMedInsurance;

  return (
    <StickyBox offsetTop={stickyOffset} className="StickySidebarBox">
      <div className={baseCls}>
        <div className={styles.sidebarInfo}>
          {(!isHomePath || isOrderFinished) && isFirstStepDone && (
            <div className={`${topCls}__item ${baseCls}__summary`}>
              <SidebarSummary />
            </div>
          )}
          <div className={styles.separator} />
          <SidebarHotel />

          {isFirstStepDone && !isManualPackage && (
            <>
              {!isHotelOnly ? (
                <TransferMedInsuranceInfo
                  sidebar
                  insurance={insurance}
                  transfer={transfer}
                />
              ) : null}
              <div className={styles.separator} />
              <div
                className={cn(`${topCls}__item`, {
                  [`${baseCls}__businesswrapper`]: isBusinessFlight,
                })}
              >
                {!isHotelOnly && (
                  <SidebarFlight className={`${baseCls}__flight`} />
                )}
              </div>
            </>
          )}

          {/* TODO: взять из селектора статусы шагов */}

          {isClientConfirmed && (
            <div className={`${topCls}__item ${baseCls}__client`}>
              <div className={styles.separator} />
              <Client {...clientData} onClick={goToClient} />
            </div>
          )}
          {isTouristsConfirmed && touristsData && (
            <>
              <div className={styles.separator} />
              <div className={`${topCls}__item ${baseCls}__tourists`}>
                <Tourists data={touristsData} onClick={goToTourists} />
              </div>
            </>
          )}
        </div>

        <SidebarMenu isHotelOnly={isHotelOnly} />
        {showFilters && <FiltersPanelDesktop />}
      </div>
    </StickyBox>
  );
};

Sidebar.propTypes = {
  clientData: PropTypes.shape({
    name: PropTypes.string.isRequired,
    phone: PropTypes.string.isRequired,
    email: PropTypes.string.isRequired,
  }),
  // TODO: вынести
  touristsData: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string,
      birthdate: PropTypes.string,
      gender: PropTypes.string,
      hideDocInputs: PropTypes.bool,
      passport_number: PropTypes.string,
    }),
  ),
  goTo: PropTypes.func.isRequired,
  isBusinessFlight: PropTypes.bool,
  isClientConfirmed: PropTypes.bool.isRequired,
  isTouristsConfirmed: PropTypes.bool.isRequired,
  isFirstStepDone: PropTypes.bool.isRequired,
  isManualPackage: PropTypes.bool.isRequired,
  isHomePath: PropTypes.bool.isRequired,
};

Sidebar.defaultProps = {
  clientData: null,
  isBusinessFlight: false,
  touristsData: null,
};

export default Sidebar;
